export const EVENTS = {
  PAGE_VIEW: 'page_view',
  CTA_CLICK: 'cta_click',
  FUNNEL_STEP: 'funnel_step',
  EXIT_PAGE: 'exit_page',
  FORM_FIELD_ABANDON: 'form_field_abandon',
};
